import { ConfirmOptions, User, PromptOptions, Tunnel } from "./index";
import { AlertRequest } from "./msg-modals-alert-req";
import { isAlertResponse, AlertResponse } from "./msg-modals-alert-res";
import { createConfirmRequest, ConfirmRequest } from "./msg-modals-confirm-req";
import { isConfirmResponse, ConfirmResponse } from "./msg-modals-confirm-res";
import { createPromptRequest, PromptRequest } from "./msg-modals-prompt-req";
import { isPromptResponse, PromptResponse } from "./msg-modals-prompt-res";
import { generateCorrelationId, isCorrelated } from "./tunnel-message-data";

/**
 * @hidden
 */
export class TunnelModalDialogService implements User {
    constructor(private readonly tunnel: Tunnel) {
    }
    alert(options: { title: string; message: string }): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            const id = generateCorrelationId();
            const subscription = this.tunnel.subscribe(function (message: MessageEvent<AlertResponse>) {
                if (isAlertResponse(message)) {
                    const response = message.data;
                    if (isCorrelated(response, id)) {
                        if (!response.err) {
                            resolve(response.value);
                        } else {
                            reject(response.err);
                        }
                        subscription.dispose();
                    }
                }
            });
            this.tunnel.postMessage<AlertRequest>({
                type: '@stemcstudio/modal-dialog-service:alert',
                id,
                title: options.title,
                message: options.message
            });
        });
    }
    confirm(options: ConfirmOptions): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            const request = createConfirmRequest(options.title, options.message, options.actionButtonText, options.cancelButtonText);
            const subscription = this.tunnel.subscribe(function (message: MessageEvent<ConfirmResponse>) {
                if (isConfirmResponse(message)) {
                    const response = message.data;
                    if (isCorrelated(response, request.id)) {
                        if (!response.err) {
                            resolve(response.value);
                        } else {
                            reject(response.err);
                        }
                        subscription.dispose();
                    }
                }
            });
            this.tunnel.postMessage<ConfirmRequest>(request);
        });
    }
    prompt(options: PromptOptions): Promise<string> {
        return new Promise<string>((resolve, reject) => {
            const request = createPromptRequest(options.title, options.message, options.text, options.label, options.hint, options.actionButtonText, options.cancelButtonText);
            const subscription = this.tunnel.subscribe(function (message: MessageEvent<PromptResponse>) {
                if (isPromptResponse(message)) {
                    const response = message.data;
                    if (isCorrelated(response, request.id)) {
                        if (!response.err) {
                            resolve(response.value);
                        } else {
                            reject(response.err);
                        }
                        subscription.dispose();
                    }
                }
            });
            this.tunnel.postMessage<PromptRequest>(request);
        });
    }
}
